import React from "react";
import FromToRangeInput from "../input/FromToRangeInput";
import { removeFromFilter, updateFilter } from "../../store/slices/filterSlice";
import { useDispatch, useSelector } from "react-redux";

const Carat = () => {
  const caratArray = [
    { label: 0.3, value: 0.3 },
    { label: 0.4, value: 0.4 },
    { label: 0.5, value: 0.5 },
    { label: 0.6, value: 0.6 },
    { label: 0.7, value: 0.7 },
    { label: 0.8, value: 0.8 },
    { label: 0.9, value: 0.9 },
    { label: 1, value: 1 },
    { label: 1.5, value: 1.5 },
    { label: 2.0, value: 2.0 },
    { label: 2.5, value: 2.5 },
    { label: 3.0, value: 3.0 },
    { label: 4.0, value: 4.0 },
    { label: "5+", value: "5+" },
  ];
  const dispatch = useDispatch();
  const filterSelect = useSelector((state) => state?.filter);
  const handleAddFilter = (value) => {
    dispatch(updateFilter({ key: "carat", value: value }));
  };
  const handleRemoveFilter = (value) => {
    dispatch(removeFromFilter({ key: "carat", value: value }));
  };
  return (
    <div className="carat-filter gap-3">
      <div className="carat-range-input">
        <FromToRangeInput
          isDecimal
          // InputWidth={"104px"}
          fromValue={filterSelect?.minCarat}
          toValue={filterSelect?.maxCarat}
          fromLabel={"From"}
          toLabel={"To"}
          mainLabel={"Carat"}
          onMinChange={(e) =>
            dispatch(
              updateFilter({ key: "minCarat", value: Number(e.target.value) })
            )
          }
          onMaxChange={(e) =>
            dispatch(
              updateFilter({ key: "maxCarat", value: Number(e.target.value) })
            )
          }
        />
      </div>
      <div className="carat-filter-range">
        <label className="filter-main-label">Carat</label>
        <div className="filter-bg-container carat-range range-outer-container">
          {caratArray.map((item) => {
            return (
              <div
                className={`range-item ${
                  filterSelect?.carat?.includes(item?.value) ? "active" : ""
                }`}
                onClick={() =>
                  filterSelect?.carat?.includes(item?.value)
                    ? handleRemoveFilter(item?.value)
                    : handleAddFilter(item?.value)
                }
              >
                {item?.label}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Carat;
